import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { useNavigate } from '@xing-com/crate-core-router';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { useFeatureSwitch } from '@xing-com/hub';
import { IconArrowLeft } from '@xing-com/icons';

import { ARMSTRONG_V1 } from '../../config/feature-switches';

import * as Styled from './edit-bar-back.styles';

export const EditBarBack: FC = () => {
  const navigate = useNavigate();
  const { pageContext } = usePageContext();

  const isArmstrong = useFeatureSwitch(ARMSTRONG_V1, false);

  return (
    <Styled.TextButton
      $isArmstrong={!!isArmstrong}
      size="medium"
      icon={IconArrowLeft}
      onClick={() =>
        navigate(`${pageContext.basePath}/${pageContext.pageSlug}`)
      }
      data-cy="back_to_overview"
    >
      <FormattedMessage id="EP_SUBPAGE_BACK" />
    </Styled.TextButton>
  );
};
